<!--分类树-->
<template>
  <el-tree
    ref="tree"
    v-loading="loadingTree"
    icon-class="gjw-iconfont gjw-icon-edit_xiala"
    :data="tree"
    :node-key="nodeKey"
    :default-expanded-keys="defaultExpanded"
    :expand-on-click-node="false"
    :highlight-current="highlight"
    @node-click="onSelect"
  >
    <template v-slot="{ data }">
      <el-tooltip :content="data.name + '('+ data[filterKey]+')'" placement="right" effect="light" :open-delay="1000" :hide-after="300">
        <div class="tree-node" :class="{'high-light':currentNode===data[nodeKey]}">
          <span>{{ data.name }}</span>
          <span class="rate-span">（{{data[filterKey]}}）</span>
        </div>
      </el-tooltip>
    </template>
  </el-tree>
</template>

<script>
export default {
  name: 'ClassifyTree',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    tree: { // 数据源
      type: Array,
      required: true
    },
    // 是否正在加载中
    loadingTree: {
      type: Boolean,
      default: false
    },
    // 作为唯一标识的key键
    nodeKey: {
      type: String,
      default: 'id'
    },
    filterKey: { // 搜索结果的key
      type: String,
      default: 'filteredCount'
    },
    expanded: {
      type: [Array]
    },
    highlight: { // 是否高亮选中的节点
      type: Boolean,
      default: true
    },
  },
  computed: {
    defaultExpanded() { // 默认展开
      return this.expanded.reduce((acc, e) => {
        if (e && (e[this.nodeKey] || e[this.nodeKey] === 0)) {
          acc.push(e[this.nodeKey])
        }
        return acc
      }, [])
    },
  },
  data() {
    return {
      currentNode: null
    }
  },
  updated() {
    const current = this.defaultExpanded[0]
    this.currentNode = current
    this.$nextTick(() => { this.$refs.tree.setCurrentKey(current) })
  },
  methods: {
    onSelect(data, node, self) {
      this.$emit('selected', data, node, self)
    }
  },
}
</script>

<style lang="less" scoped>
  .high-light {
    width: 100%;
    color: @theme-color;
  }

  .tree-node {
    width: 100%;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  // 插件的叶子节点左侧padding需要减小
  /deep/.el-tree-node__content {
      padding-left: 10px !important;
    }
  /deep/.el-tree-node__children {
      .el-tree-node__content {
        padding-left: 14px !important;
      }
      .el-tree-node__children{
        .el-tree-node__content {
          padding-left: 20px !important;
        }
        .el-tree-node__children{
          .el-tree-node__content {
            padding-left: 28px !important;
          }
        }
      }
    }
 /deep/.el-tree-node__expand-icon.expanded{
  transform: rotate(0deg);
 }
 /deep/.el-tree-node__expand-icon{
  transform: rotate(-90deg);
 }

  .icon-span {
    position: absolute;
    right: 10px;
    display: none;

    i {
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
.test{
  background-color: #f56c6c; /* 提示框背景色 */
  color: #fff; /* 文本颜色 */
    }
</style>
